export const digitalMarketingNavBar = [
  {
    text: "Digital Marketing",
    icon: "mdi-chart-line",
    to: "/digital-marketing",
  },
];
